import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default (props) => {


  const blockchainLinks = (tx) => {
    switch (props.coin) {
      case "btc":
        return 'https://www.blockchain.com/en/btc/tx/' + tx; // + '/';
      case "ltc":
        return 'https://blockchair.com/litecoin/transaction/' + tx + '/';
      case "dash":
        return 'https://explorer.dash.org/insight/tx/' + tx + '/';
      case "eth":
        return 'https://etherscan.io/tx/' + tx;
      case "bch":
        return 'https://explorer.bitcoin.com/bch/tx/' + tx + '/';
      case "xrp":
        return 'https://livenet.xrpl.org/transactions/' + tx;
      case "usdt":
        return 'https://solscan.io/tx/' + tx;
      case "sol":
        return 'https://solscan.io/tx/' + tx;
      default:
        return '';
    }
  }

  const renderDeposits = () =>{
    return props.deposits.map(i =>{
      return(
        <tr>
          <th className='medium-dms dark-text txid-th'>
              <p onClick={()=>window.open(blockchainLinks(i.txid),'_blank')}>{i.txid}</p>
          </th>
          <th className='medium-dms gray-text'>
            {i.crypto_amount}
          </th>
          <th className='medium-dms gray-text'>
            {i.usd_amount}
          </th>
        </tr>
      )
    })
  }
  return(
    <Row>
      <Col>
        <div style={{height:30}}/>
        <p className='medium-dms dark-text font-22'>{props.translations.checkout.deposits.deposits_title}</p>
        <div className='container-transactions'>
          <div className='order-divider'/>
          <div style={{width:'100%', overflow:'hidden'}}>
            <table style={{width:'100%', overflow:'hidden'}} className='deposits-table'>
              <tr>
                <th className='medium-dms dark-tex' style={{width:'50%'}}>
                {props.translations.checkout.deposits.deposits_TXID_column}
                </th>
                <th className='medium-dms dark-text'>
                  {props.translations.checkout.deposits.deposits_amount_crypto_column} {props.coin.toUpperCase()}
                </th>
                <th className='medium-dms dark-text'>
                  {props.translations.checkout.deposits.deposits_amount_currency_column} {props.currency.toUpperCase()}
                </th>
              </tr>
              {renderDeposits()}
            </table>
          </div>
        </div>
      </Col>
    </Row>
  )
}
